export const priceWithCommission = (price, commission) => {
  const p = Number(price) || 0;
  const c = Number(commission) || 0;
  return p + p * (c / 100);
};
